import http from 'hub-http/clients/apiClient';
import * as reportingHttp from '../../../request/http';
import { fromJS } from 'immutable';
const API_URL = 'reporting/v1/report';
const V2_API_URL = 'reporting/v2/report';
const defaultByQueryReportOptions = fromJS({
  limit: 1000,
  offset: 0,
  fetchFromCache: false,
  updateCache: true
});
const defaultByIdReportOptions = fromJS({
  limit: 1000,
  offset: 0,
  forceSnowflakeQuery: false
});
const disableCacheOption = {
  ttl: 0
};

/**
 * Kick off a new async query to the ReportingApi. Might return a successful
 * response if the query finishes quickly.
 */
export const fetchWithReportDefinition = (reportWithOptions, reportId, queryId) => {
  const updatedReportWithOptions = reportWithOptions.update('reportOptions', previousValue => previousValue || defaultByQueryReportOptions)
  // Use passedIn reportId if reportWithOptions doesn't have a reportId defined
  .update('reportId', previousValue => previousValue || reportId);
  let data = updatedReportWithOptions.toJS();
  if (queryId) {
    data = Object.assign({}, data, {
      queryId
    });
  }
  return reportingHttp.post(V2_API_URL, {
    data
  }, Object.assign({}, disableCacheOption)).then(fromJS);
};
/**
 * Get the result of an existing async query via ReportingApi, such as a running
 * query. Useful for polling for a result.
 */
export const fetchWithQueryId = (reportWithOptions, queryId) => reportingHttp.post(V2_API_URL, {
  data: Object.assign({
    queryId
  }, reportWithOptions.toJS())
}, Object.assign({}, disableCacheOption)).then(fromJS);

/**
 * Retrieve a report dataset from the ReportingApi by report id.
 */
export const fetchWithReportId = (reportWithOptions, reportId) => reportingHttp.get(`${API_URL}/${reportId}`, {
  query: reportWithOptions.get('reportOptions', defaultByIdReportOptions).toJS()
}, Object.assign({}, disableCacheOption)).then(fromJS);

/**
 * Cancel an existing async query by query id via ReportingApi. Cached async
 * query response will result in the status "CANCELLED".
 */
export const cancelRequest = queryId => http.delete(`${V2_API_URL}/query/${queryId}`);
export const __TESTABLE__ = {
  defaultByQueryReportOptions
};